import "./OurSpecialists.module.css";
import Header from "@/reusable_sections/Header";
import Neurosurgeons from "./sections/Neurosurgeons";
import Prototype from "./sections/Prototype";
import Footer from "@/reusable_sections/Footer";
import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
function Hero() {
  return <section className="relative w-full overflow-hidden bg-[#264256] flex items-center justify-center min-h-[40vh] md:min-h-[50vh] text-foreground py-10 md:py-16">
      <div className="relative z-20 container mx-auto px-6 flex flex-col items-center text-center max-w-5xl">
        <span className="font-default text-[12px] text-accent-foreground uppercase tracking-widest mb-4 md:mb-8 block font-semibold">
          EU Cross-Border Healthcare Directive
        </span>
        <h1 className="font-default font-bold text-4xl md:text-[60px] leading-[1.1] text-white tracking-normal mb-4 md:mb-8 max-w-4xl">
          Our medical team.
        </h1>
        <p className="font-default font-medium text-base md:text-[20px] text-white/90 leading-relaxed max-w-2xl mb-8 md:mb-12">
          Pain specialists and neurosurgeons at Clinic Agatas in Kaunas, Lithuania.
        </p>
        <Button asChild className="rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 h-12 md:h-14 px-8 md:px-10 text-sm uppercase tracking-widest transition-all duration-300 border border-ring shadow-md">
          <Link to="/#request-your-consultation">Book a Consultation</Link>
        </Button>
      </div>
    </section>;
}
export default function OurSpecialistsPage() {
  return <div>
      <Header />
      <Hero />
      <Neurosurgeons />
      <Prototype />
      <Footer />
    </div>;
}